import { lazy } from 'react';
const RELOAD_KEY = 'teambridge_chunk_reload';

// After a deploy, a tab that still runs the previous build asks for chunk files
// that no longer exist. Reload once to pick up the new build; if the reload
// already happened in the last minute, surface the error instead of looping.
export function retryChunk(load, storage = window.sessionStorage, location = window.location) {
  return load().catch(error => {
    const isChunkError = error?.name === 'ChunkLoadError' || /Loading chunk .* failed/i.test(error?.message || '');
    let last = 0;
    try {
      last = Number(storage.getItem(RELOAD_KEY)) || 0;
    } catch (_) {/* storage is optional */}
    if (!isChunkError || Date.now() - last < 60000) throw error;
    try {
      storage.setItem(RELOAD_KEY, String(Date.now()));
    } catch (_) {/* storage is optional */}
    location.reload();
    return new Promise(() => {});
  });
}

// A route component loaded on demand. `preload` starts the download early
// (preloadPage); rendering reuses the same promise, so an error while loading
// reaches the error boundary as itself.
export default function lazyPage(load) {
  let pending = null;
  const loadOnce = () => {
    if (!pending) pending = load();
    return pending;
  };
  const Page = /*#__PURE__*/lazy(() => retryChunk(loadOnce));
  Page.preload = loadOnce;
  return Page;
}